import * as S from "./styles.ts";
import Link from "next/link";
import { ChevronRight } from "@template/icons";
import Image, { ImageProps } from "@template/components/Image";

export interface IBentoBoxProps {
  info: {
    heading: string;
    subHeading: string;
    link?: {
      text: string;
      href: string;
      title: string;
    };
    image: ImageProps;
    cta?: {
      text: string;
      href: string;
    };
    flip?: boolean;
  };
  width?: string;
  height?: string;
  alignRight?: boolean;
}

const BentoBox = ({ info, height, width, alignRight }: IBentoBoxProps) => {
  return (
    <S.BentoBoxWrapper
      width={width}
      height={height}
    >
      <S.BentoSectionItem $flip={info.flip}>
        <S.BentoSectionItemContent>
          <S.BentoSectionItemHeading>{info.heading}</S.BentoSectionItemHeading>
          <S.BentoSectionItemSubHeading>
            {info.subHeading}
          </S.BentoSectionItemSubHeading>
          {info.link && (
            <Link
              href={info.link.href}
              title={info.link.title}
            >
              <S.BentoSectionItemLink>
                {info.link.text}
                <ChevronRight />
              </S.BentoSectionItemLink>
            </Link>
          )}
        </S.BentoSectionItemContent>
        <S.BentoSectionItemImageContainer $alignRight={alignRight}>
          <Image
            style={{ width: "100%", height: "100%" }}
            {...info.image}
          />
        </S.BentoSectionItemImageContainer>
      </S.BentoSectionItem>
    </S.BentoBoxWrapper>
  );
};

export default BentoBox;
